import React, { useEffect, useState } from 'react';
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom"
import { BASE } from "../basedata/constants";
import FacialInstructions from "../components/Intructions/FacialInstructions";
import MobilePagination from '../components/MobilePagination/MobilePagination';
import { useTranslation } from 'react-i18next';
import "./FacialInstructionsPage.sass"
import { useStep } from '../context/StepContext'
import { UnicoCheckBuilder, SelfieCameraTypes, UnicoThemeBuilder, SDKEnvironmentTypes, DocumentCameraTypes, UnicoConfig, LocaleTypes } from 'unico-webframe'
import SelfieDone from '../components/SelfieDone/SelfieDone';
import SelfieSuccess from '../components/SelfieSuccess/SelfieSuccess';
import { GoSaffeCapture } from '@go.saffe/go-saffe-react-js';
import { isMobile } from 'react-device-detect';

const FacialInstructionsPage = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language?.split('-')[0] as 'pt' | 'en' | 'es';
    const navigate = useNavigate();
    const { setStep } = useStep();
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [faceStep, setFaceStep] = useState('instructions');
    const [selfieImage, setSelfieImage] = useState('');
    const [selfieImageEncripted, setSelfieImageEncripted] = useState('');

    const [provider_token, setProvider_token] = useState('');
    const [profiverDocument, setProfiverDocument] = useState('');

    useEffect(() => {



      
      if(!sessionStorage.getItem('user_document') || !sessionStorage.getItem('token')) {
        navigate('/signup');
      }

      if(!isMobile){
        window.location.href = `/mobile-handler?token=${sessionStorage.getItem('token') || null}`
      }
      
      setProvider_token(sessionStorage.getItem('token') || '');
      setProfiverDocument(sessionStorage.getItem('user_document') || '');
      setStep(3);
    }, []);


  const openCamera = async (cameraType: string = 'liveness') => {

    return setFaceStep('gosaffe')

    // const GoSaffe = (window as any).GoSaffe;
    
    // if (!GoSaffe) {
    //   console.error('GoSaffe library not loaded');
    //   setError('SDK not available');
    //   return;
    // }
  };

    return (

      loading ? (
        <div className="loader">
          <div className="spinner">
          </div>
        </div>
      ):(
       <>
      {BASE.company.iframe_liveness === false ? (

      <FacialInstructions
        handleCloseInstructions={() => navigate('/selfie')}
        togglePanel={() => { }}
      />
      ):(
      faceStep === 'instructions' ? (
      <FacialInstructions
        handleCloseInstructions={openCamera}
        togglePanel={() => { console.log('foi u, dos, re') }}
      />
      ):(
        <GoSaffeCapture
      captureKey='821aaab8-55ee-4de6-946c-d58bae17814a' // capture key (sandbox or production)
      user={`${profiverDocument.replaceAll('.', '').replaceAll('-', '')}@${BASE.company.tenant.split('-').slice(0, -1).join('-')}.com.br`} // end-user identifier (either email or CPF)
      type='onboarding' // 'onboarding' or 'verification'
      endToEndId={provider_token} // identifier to keep consistency between front and backend
      onClose={() => {
       return window.location.href = '/instructions';
        }} // callback function called when end-user closes (cancels) the capture
      onFinish={() => { 
        window.location.href = '/thinking';
        } }// callback function called when end-user finishes (completes) the capture
      onTimeout={() => {
        window.location.href = '/thinking';
      }} // callback function called when the capture ends for timeout
      extraData={{ // optional extra configuration
        settings: {
          primaryColor: `${BASE.company.primaryColor}`, // primary color for the capture interface
          secondaryColor: `${BASE.company.secondaryColor}`, // secondary color for the capture interface
          lang: currentLang
        }
      }}
    />
      ))}
      </>
      )
      );
};

export default FacialInstructionsPage;
